<template>
  <div>
    <UiModal :open="status_poppad_form" @close="status_poppad_form = false">
      <div v-if="on_step === 'form'" class="p-5">
        <h4 class="tac">
          {{lg('',{
            en: 'Welcome',
            zh: '欢迎',
          })}}
        </h4>

        <div class="tac mt-4">

          <label class="label-with-input-file-hidden">
            <span :class="['ui-avatar size-80 cp',{'on-loading':sync_avatar.status_uploading}]">
              <img :src="sync_avatar.img_url || '/static/pic/default_pic/default_avatar.jpg'">
            </span>

            <div class="tac mt-1">
              <span class="cp small">
                {{lg('',{
                  en: 'Choose Profile Picture',
                  zh: '上传头像',
                })}}
              </span>
            </div>

            <CpUniUpload
              :sync_obj="sync_avatar"
              :conf="{
                target_folder_name: 'jgn_avatar/',
                filetype_allowed: ['jpg','jpeg','png','webp','gif'],
                compress_cfg: {
                  maxWidth: 150,
                  maxHeight: 150,
                },
              }"
            />
          </label>
        </div>

        <div>
          <div class="mt-3">
            <h5 class="b">
              {{lg('',{
                en: 'Display Name',
                zh: '用户名',
              })}}*
            </h5>
            <input 
              v-model.trim="form.username" 
              type="text" 
              class="form-control"
              placeholder="Enter your display name"
            >
            <small class="t-gray">
              {{lg('',{
                en: 'Only use letters, numbers, underscores and emojis',
                zh: '可输入字母、数字、下划线和emoji',
              })}}
            </small>
          </div>

          <div v-if="0" class="mt-3">
            <small class="t-gray">
              {{lg('email')}}*
            </small>
            <input 
              v-model="form.email" 
              type="text" 
              class="form-control"
              placeholder="example@email.com"
            >
            <small class="t-gray ml-3">
              {{lg('',{
                en: 'Be the first to know when new NFTs are added!',
                zh: '第一时间了解最新的收藏品添加',
              })}}
            </small>
          </div>

          <div class="mt-3">
            <h5 class="b">
              {{lg('',{
                en: 'Bio',
                zh: '个人简介',
              })}}
            </h5>
            <input 
              v-model="form.bio" 
              type="text" 
              class="form-control"
              placeholder="Tell us a little about yourself" 
            >
            <small class="t-gray">
              {{lg('',{
                en: 'URLs are allowed',
                zh: '也可添加URL',
              })}}
            </small>
          </div>

          <div class="mt-3 tac">
            <span @click="next('confirm')" class="btn btn-primary btn-round">
              {{lg('next')}}
            </span>
          </div>
        </div>
      </div>

      <div v-if="on_step === 'confirm'" class="p-5">
        <h4 class="tac">
          {{lg('',{
            en: 'JGNNFT Terms of Service',
            zh: 'JGNNFT 服务条款',
          })}}
        </h4>
        <div class="mt-4 tac small">
          
          {{lg('',{
            en: 'Please take a few minutes to read and understand ',
            zh: '请您花几分钟时间阅读',
          })}}
          <router-link to="/">
            <span class="c">
              
              {{lg('',{
                en: 'JGNNFT Terms of Service',
                zh: 'JGNNFT服务条款声明',
              })}}
            </span>
          </router-link>. 
          
          {{lg('',{
            en: 'To continue, you’ll need to accept the Terms of Service by checking the box.',
            zh: '您需要点击同意这些条款，才可进行下一步操作。',
          })}}
        </div>

        <div class="mt-4">
          <!-- <div class="mb-2">
            <label>
              <input v-model="term_checked_age" type="checkbox">
              
              {{lg('',{
                en: 'I am at least 13 years old',
                zh: '我超过13岁了',
              })}}
            </label>
          </div> -->
          <div class="mb-2">
            <label>
              <input v-model="term_checked_aggre" type="checkbox">
              
              {{lg('',{
                en: 'I accept the JGNNFT Terms of Service',
                zh: '我接受JGNNFT的服务条款',
              })}}
            </label>
          </div>
        </div>

        
        <div class="mt-3 tac">
          <span 
            @click="next('save')" 
            class="btn btn-primary btn-round"
            :disabled="!term_checked_age || !term_checked_aggre"
            >
            {{lg('',{
              en: 'Proceed',
              zh: '继续',
            })}}
          </span>
        </div>
      </div>
    </UiModal>


  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'blockSiginup',
  components: {},
  props: [
    'mark_ui_call',
  ],
  data() {
    return {

      on_step: 'form',

      sync_avatar: {
        img_url: '',
        status_uploading: false,
        status_upload_percent: 0,
      },

      form: {
        username: '',
        email: '',
        bio: '',
        imageURL: '',
      },
      // age 检查已经取消
      term_checked_age: true,
      term_checked_aggre: false,

      status_poppad_form: false,
    }
  },
  computed: {},
  watch: {
    'mark_ui_call'(val){
      if(val){
        this.run()
      }
    },

    'sync_avatar.img_url'(val){
      this.form.imageURL = val
    },
  },
  methods: {
    ...mapActions([
      'accountSign',
    ]),

    async next(str){
      let v = this
      if(str === 'confirm'){
        if(
          !v.form.username
        ){
          return
        }
        v.on_step = 'confirm'
      }
      if(str === 'save'){
        if(v.term_checked_age && v.term_checked_aggre){
          // todo...
          let address_my = v.$store.state.web3.account
          let sig = await v.accountSign(address_my)


          let res = await v.api('signup',{
            address: address_my,
            sign: sig,
            username: v.form.username,
            email: v.form.email,
            bio: v.form.bio,
            imageURL: v.form.imageURL,
          })

          v.status_poppad_form = false
          v.uniCheckUserLogin()
        }
      }
    },

    run(){
      this.on_step = 'form'
      this.status_poppad_form = true
    },
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>